import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRemarks } from '../../actions/admin';
import Select from '../../common/Form/Select';
import { debounce } from '../../utils/common';
import { CLEAR_REMARKS_LIST_DROPDOWN_LIST_DATA } from '../../types/admin';
import { useFormContext } from 'react-hook-form';

const Dependency = ({ name, label, onChange = () => { }, org_id, project_id, required = true, className, isMulti = false, prefill }) => {
    const dispatch = useDispatch();
    const remarksListDropdown = useSelector((state) => state.admin.remarksListDropdown);
    const isRemarksLoading = useSelector((state) => state.loading.isRemarksLoading);
    const category = 'DEPENDENCY';
    const methods = useFormContext({ defaultValues: {}, mode: 'all' });

    const getRemarksList = ({ limit = 100, page = 1, query = '', org_id, project_id }) => {
        dispatch(getRemarks({ limit, page, query, org_id, category, project_id, dropdown: true }));
    };

    const debouncedRemarksSearchSearch = useCallback(debounce(getRemarksList), []);

    const remarksList = useMemo(() => {
        let l = [];
        if (remarksListDropdown?.[category]) {
            l = [...remarksListDropdown[category]];
        }
        return l;
    }, [remarksListDropdown, category]);

    useEffect(() => {
        getRemarksList({ limit: 100, page: 1, query: '', org_id, project_id });
    }, [org_id, project_id]);

    useEffect(() => {
        if (prefill && Object.keys(prefill).length > 0) {
            const selectedOptions = remarksList.find(option => prefill.id === option.id);
            methods.setValue(name, selectedOptions);
            onChange(selectedOptions);
        }
    }, [prefill, remarksList]);

    useEffect(() => {
        return () => {
            dispatch({ type: CLEAR_REMARKS_LIST_DROPDOWN_LIST_DATA, payload: category });
        }
    }, [dispatch]);

    return <Select
        name={name}
        label={label}
        options={remarksList}
        isLoading={isRemarksLoading}
        required={required}
        shouldUnregister
        onChange={(event) => {
            const value = event?.value;
            onChange(value)
        }}
        onInputChange={(event) => {
            if (event.length > 0) {
                debouncedRemarksSearchSearch({ query: event, org_id })
            }
        }}
        className={className}
        isMulti={isMulti}
    />
}

export default Dependency;
